import { toast } from '@randstad-lean-mobile-factory/react-components-core';
import { UseMutationOptions, useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { OnCallCentersService, UpdateOnCallCenterBody } from '../../Services/API';
import { MutationKeys, QueryKeys } from '../types';

export const useRemoveAgenciesToOnCallCenter = (
  extraOptions?: UseMutationOptions<void, AxiosError, UpdateOnCallCenterBody>
) => {
  const queryClient = useQueryClient();

  return useMutation(
    [MutationKeys.deleteAgenciesFromOnCallCenter],
    async (params: UpdateOnCallCenterBody) => {
      return OnCallCentersService.onCallCentersControllerDeleteAgenciesFromOnCallCenter({
        body: params,
      });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [QueryKeys.fetchOnCallCenters] });
      },
      onError: (error: AxiosError) => {
        if (error.response?.status === 403) {
          toast.error('Droits insuffisants pour créer des routages');
        } else {
          toast.error('Une erreur est survenue lors de la suppression des agences à la permanence');
        }
      },
      ...extraOptions,
    }
  );
};
